/**
 * Convert a rule title (or any string) to a URL slug.
 * Lowercase, spaces to hyphens, remove non-alphanumeric.
 * @param {string} title
 * @returns {string}
 */
export function titleToSlug(title) {
  if (!title || typeof title !== 'string') return '';
  return title
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'rule';
}

/**
 * Build the rule detail path with optional slug.
 * @param {string|number} id
 * @param {string} [slug] - from API or titleToSlug(title)
 * @returns {string} e.g. "/rules/123/procrastination-is-the-way"
 */
export function rulePath(id, slug) {
  if (!id) return '/rules';
  const base = `/rules/${id}`;
  if (slug) return `${base}/${slug}`;
  return base;
}
